import { Component, OnInit, Input } from '@angular/core';
import { FileInfoType } from '@schoolbelle/api/file';

@Component({
  selector: 'app-file-name-text',
  templateUrl: './file-name-text.component.html',
  styleUrls: ['./file-name-text.component.scss']
})
export class LetterWriteFileListFileNameTextComponent implements OnInit {

  @Input() file:FileInfoType|File;
  constructor() { }

  ngOnInit() {
  }

}
